import { useQuery } from '@office-start/data-fetching';
import { getInstrumentedTopCachedData } from '../operations/getInstrumentedTopCachedData';
export function useEdgeworthCachedTopItems(preloadedCacheEntries) {
    var query = ['EdgeworthData', "CachedTop" /* QuerySubtype.CachedTop */];
    return useQuery(query, function () { return preloadedCacheEntries || getInstrumentedTopCachedData(); }, {
        cacheTime: Infinity,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
    });
}
//# sourceMappingURL=useEdgeworthCachedTopItems.js.map